import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { RegistrationModel } from "../registration.models";
import { Error } from "@bt/shared";

@Component({
    selector: 'registration-form',
    templateUrl: './component.html'
})
export class RegistrationFormComponent implements OnInit {
    @Input() public error: Error;
    @Input() public showLoader: boolean;
    @Output() public onRegister = new EventEmitter<RegistrationModel>();
    @Output() public onClearError = new EventEmitter();
    public registrationForm: FormGroup;

    constructor(private fb: FormBuilder) { }

    public ngOnInit() {
        this.registrationForm = this.fb.group({
            email: null,
            password: null,
            passwordConfirmation: null,
            agree: false
        });

        this.registrationForm.valueChanges
            .filter(() => !!this.error)
            .forEach(() => {
                this.clearError();
            });
    }

    public signUp() {
        const creds: RegistrationModel = this.registrationForm.value;
        this.onRegister.emit(creds);
    }

    private clearError() {
        this.error = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/public/registration/form/component.ts